import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import actions from '@/redux/action';
import { request } from '@/api/request';
import Utils from '@/utils';
import sentGAEvent from '@/ga';

import Process from '../../common/process/Process';
import ToGIFWorkFunction from './children/ToGIFWorkFunction';
import ToGIFWorkSuccessRender from './children/ToGIFWorkSuccessRender';
import TipsModal from '../../common/tipModal/TipsModal';

import '@/assets/toGIF.less';

class ToGIFWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoAccept:
        'video/*, .mkv, .mov, .mp4, .avi, .wmv, .vob, .webm,  .asf, .f4v, .flv, .mpg, .mpeg, .ts, .mxf, .ogv, .gif',
      waitingUpload: false,
      submitFail: false,
      submitFailMsg:
        'Processing failed. Get HitPaw Toolkit for stable processing.',
    };
  }

  handleCloseFile = () => {
    this.props.onToGifObjChange(null);
    this.props.onCurrFileChange(null);
  };

  handleSubmit = async () => {
    const startTime = { ...this.props.startTime };
    startTime.gif = new Date();
    this.props.onStartTimeChange(startTime);
    if (!this.props.uploading && this.props.uploadPercent < 100) {
      this.props.onProcessStepChange(1);
      this.props.onProcessPercentChange(1);
    }
    let gifResponse;
    try {
      gifResponse = await this.requestGif();
      console.log('gifResponse', gifResponse);
    } catch (error) {
      this.setState({ submitFail: true });
      this.props.onProcessPercentChange(0);
      this.props.onProcessStepChange(0);
      this.props.onSubmittingChange(false);
      sentGAEvent({
        category: 'ToGif',
        action: 'GifFail',
        label: error + '_none_none_' + this.props.tokenId + '_none_none',
      });
      return false;
    }
    if (gifResponse.code === 200) {
      sentGAEvent({
        category: 'ProcessStart',
        action: '37TG_ProcessStart',
      });
      const number = gifResponse.data.result.number;
      let progressResponse;
      try {
        progressResponse = await Utils.getProgress(number, false);
      } catch (error) {
        if (error !== 'cancel') {
          this.setState({ submitFail: true });
          sentGAEvent({
            category: 'ToGif',
            action: 'GifFail',
            label: 'videotogif_200_200_' + error,
          });
        }
        this.props.onProcessPercentChange(0);
        this.props.onProcessStepChange(0);
        this.props.onSubmittingChange(false);
        return false;
      }
      if (progressResponse.code === 200) {
        sentGAEvent({
          category: 'ProcessStart',
          action: '37TG_ProcessStart',
        });
      }
      sentGAEvent({
        category: 'ProcessSuccess',
        action: '37TG_ProcessSuccess',
      });
      const videofileurl = gifResponse.data.response_file[0];
      const duration = moment('00:00:00', 'mm:ss:SS')
        .add(parseFloat(progressResponse.info[0].duration), 'seconds')
        .format('mm:ss:SS')
        .replace(/:([^:]*)$/, '.$1');
      const size = progressResponse.info[0].size;
      const wh = progressResponse.info[0].wh.match(/^\d+x\d+/)[0];
      const fps = progressResponse.info[0].fps;
      const screenshots = progressResponse.thumbnail[0].img;
      const thumbnail = screenshots[0];
      let videoObj = {
        name:
          'HitPawOnline_' +
          new Date().getHours() +
          new Date().getMinutes() +
          new Date().getSeconds() +
          '.gif',
        duration: duration,
        size: size,
        thumbnail: thumbnail,
        status: 'success',
        videofileurl,
        screenshots: screenshots,
        mark: false,
        wh: wh,
        fps: fps,
        uploadStatus: true,
      };
      const modal = {
        show: true,
        type: 'gifSuccess',
        newObj: videoObj,
      };
      this.props.onFileListModalChange(modal);
      this.props.onUploadPercentChange(0);
      this.props.onProcessPercentChange(0);
      this.props.onSubmittingChange(false);
      sentGAEvent({
        category: 'ToGif',
        action: 'GifSuccess',
      });
    } else {
      if (gifResponse.code === 402102) {
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
          trigger: '6TrialOver',
        });
      } else {
        this.setState({ submitFail: true });
      }
      this.props.onUploadPercentChange(0);
      this.props.onProcessPercentChange(0);
      this.props.onSubmittingChange(false);
      sentGAEvent({
        category: 'ToGif',
        action: 'GifFail',
        label:
          'videotogif_200_' +
          gifResponse.code +
          '_none_' +
          this.props.tokenId +
          '_none_' +
          gifResponse.msg,
      });
    }
  };

  preSubmit = (isUnkownTaskRequest) => {
    if (this.props.uploading) {
      console.log('提交正在上传');
      if (!isUnkownTaskRequest) {
        this.props.onProcessStepChange(this.props.processStep + 1);
      }
      setTimeout(() => {
        this.props.onSubmittingChange(true);
      }, 500);
      // 提交前文件正在上传
      this.setState({ waitingUpload: true });
      return false;
    } else if (
      !this.props.uploading &&
      this.props.currFile &&
      !this.props.currFile.uploadStatus
    ) {
      // 提交前文件上传失败
      console.log('提交前文件上传失败');
      this.props.onSubmittingChange(true);
      this.setState({ waitingUpload: true });
      this.props.onUploadAgainFileChange(this.props.currFile);
      this.props.onCurrFileChange(null);
      this.props.onPreUploadFileChange(this.props.currFile.fileObj);
    } else if (
      !this.props.uploading &&
      this.props.currFile &&
      this.props.currFile.uploadStatus
    ) {
      console.log('提交前文件上传成功');

      //提交前文件上传成功
      this.setState({ waitingUpload: false });
      this.props.onSubmittingChange(true);
      this.handleSubmit();
    }
  };

  requestGif = () => {
    const formData = new FormData();
    formData.append('ext', 'gif');
    formData.append('start_time', this.props.toGifObj.start);
    formData.append(
      'continued_time',
      moment
        .duration(
          moment(
            this.props.toGifObj.end.replace('.', ':'),
            'mm:ss:SS'
          ).valueOf() -
            moment(
              this.props.toGifObj.start.replace('.', ':'),
              'mm:ss:SS'
            ).valueOf()
        )
        .as('seconds')
    );
    formData.append('video_url', this.props.currFile.videofileurl);
    if (this.props.toGifObj.resolution === 'origin') {
      const file = this.props.currFile;
      formData.append(
        'resolution',
        `${file.wh.substring(0, file.wh.indexOf('x'))}:-1`
      );
    } else if (this.props.toGifObj.resolution === 'custom') {
      formData.append(
        'resolution',
        `${
          this.props.toGifObj.width === 'AUTO'
            ? '-1'
            : this.props.toGifObj.width
        }:${
          this.props.toGifObj.height === 'AUTO'
            ? '-1'
            : this.props.toGifObj.height
        }`
      );
    } else {
      formData.append('resolution', this.props.toGifObj.resolution);
    }
    formData.append('number_of_frames', this.props.toGifObj.framesRate);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request('convertGif', {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.uploading &&
      !this.props.uploading &&
      this.state.waitingUpload &&
      this.props.submitting
    ) {
      this.preSubmit();
    }
  }

  render() {
    return (
      <div className='workplace'>
        <ToGIFWorkFunction
          preSubmit={(isUnkownTaskRequest) => {
            sentGAEvent({
              category: 'ToGif',
              action: 'GifSave',
              label:
                Utils.getSeconds(this.props.toGifObj.end) -
                Utils.getSeconds(this.props.toGifObj.start) +
                's_' +
                this.props.toGifObj.resolution +
                '_' +
                this.props.toGifObj.framesRate,
            });

            let flag = Utils.handleVideoEditorTimes();
            if (flag) {
              return false;
            }

            this.preSubmit(isUnkownTaskRequest);
          }}
          toGifObj={this.props.toGifObj}
          onToGifObjChange={this.props.onToGifObjChange}
          handleCloseFile={this.handleCloseFile}
        />
        <Process />
        <ToGIFWorkSuccessRender
          fileListModal={this.props.fileListModal}
          onToGifObjChange={this.props.onToGifObjChange}
          onFileListModalChange={this.props.onFileListModalChange}
          onCurrFileChange={this.props.onCurrFileChange}
        />
        <TipsModal
          visible={this.state.submitFail}
          content={this.state.submitFailMsg}
          onCancel={() => {
            this.setState({ submitFail: false });
          }}
          cancelBtnHandle={this.cancelAgain}
          confirmBtnHandle={this.submitAgain}
          confirmBtnText='Try Again'
        />
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  toGifObj: state.work.toGifObj,
  uploading: state.work.uploading,
  currFile: state.files.currFile,
  processStep: state.work.processStep,
  submitting: state.work.submitting,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  fileListModal: state.common.fileListModal,
  startTime: state.work.startTime,
});

const mapDispatchToProps = (dispatch) => ({
  onToGifObjChange: (toGifObj) => dispatch(actions.onToGifObjChange(toGifObj)),
  onCurrFileChange: (currFile) => dispatch(actions.onCurrFileChange(currFile)),
  onSubmittingChange: (submitting) =>
    dispatch(actions.onSubmittingChange(submitting)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onPreUploadFileChange: (preUploadFile) =>
    dispatch(actions.onPreUploadFileChange(preUploadFile)),
  onUploadAgainFileChange: (uploadAgainFile) =>
    dispatch(actions.onUploadAgainFileChange(uploadAgainFile)),
  onStartTimeChange: (startTime) =>
    dispatch(actions.onStartTimeChange(startTime)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onFileListModalChange: (fileListModal) =>
    dispatch(actions.onFileListModalChange(fileListModal)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(ToGIFWork);
